import { render } from "./PopUpCliente.vue?vue&type=template&id=14398535&scoped=true"
import script from "./PopUpCliente.vue?vue&type=script&lang=js"
export * from "./PopUpCliente.vue?vue&type=script&lang=js"

import "./PopUpCliente.vue?vue&type=style&index=0&id=14398535&scoped=true&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14398535"]])

export default __exports__